module.exports = __webpack_public_path__ + "static/media/image_left_arrow_selection.4811fd86.png";